import { render, staticRenderFns } from "./VLeaseNotesSection.vue?vue&type=template&id=1121f966&"
import script from "./VLeaseNotesSection.vue?vue&type=script&lang=js&"
export * from "./VLeaseNotesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports